import { z } from 'zod';
import { fallback } from '@tanstack/router-zod-adapter';
export const addOwnerSelectionQueryParamsSchema = z.object({
  uboId: fallback(z.string().optional(), undefined),
});
